import { render } from "./SurveyResults.vue?vue&type=template&id=4680423b&ts=true"
import script from "./SurveyResults.vue?vue&type=script&lang=ts"
export * from "./SurveyResults.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__